<template>
	<div class="contenedor-selector-orden">
		<label for="selectororden">Ordenar por</label>
		<select id="selectororden" name="selector-orden" v-model="seleccionado" >
				<option value="numero-nodos">Número de participantes</option>
			<option value="numero-enlaces">Número de enlaces</option>
			<option value="paciente-mas-reciente">Participante más reciente</option>
			<option value="densidad-cluster">Densidad del cluster</option>
		</select>
	</div>
</template>
<script>
export default {
  name: 'SelectorOrden',
	computed: {
		seleccionado: {
			get () {
      			return this.$store.state.orden_clusters
			},
			set (value) {
				this.$store.commit('cambiarOrdenClusters', value)
			}
		}
	},
}
</script>

<style scoped lang="scss">
.contenedor-selector-orden {
	position: absolute;
	z-index: 2;
	@media (min-width: map-get($media-queries-limit, "mobile")) {
		right: $gap*.5;
	}
	label {
		font-size: 14px;
		display: inline-block;
		padding-right: $gap*.25;
		@media (min-width: map-get($media-queries-limit, "mobile")) {
			padding-right: $gap*.5;
			font-size: 16px;
		}
	}
	select {
		font-size: 14px;
		background: #fff;
		border: transparent;
		height: 30px;
		box-shadow: 0px 3px 6px #00000011;
		border: 1px solid #ccc;
		border-radius: 5px;
		padding: 0 $gap*.25;
		cursor: pointer;
		@media (min-width: map-get($media-queries-limit, "mobile")) {
			padding: 0 $gap*.5;
			font-size: 16px;
		}
		&:hover,
		&:focus {
			border: 1px solid #ddd;
			box-shadow: 0px 3px 6px #00000044;
		}
	}
}

</style>
